import newbornService from "./newbornService";

const caseInfoService = [
    ...newbornService
];

export { caseInfoService as default, newbornService }